export default __webpack_public_path__ + "static/media/bastion-icon.3f8ad7ba.webp";